export class ErrorRenderer{

	public constructor(private container:HTMLElement,private msg:string){
	}

	public render(){
		var entryHtml = document.createElement("div");
		var errorHtml = document.createElement("div");
		errorHtml.innerHTML = this.msg;
		entryHtml.appendChild(errorHtml);
		this.container.appendChild(entryHtml);
	}
}